export default __webpack_public_path__ + "738b187f77b4ebce9e09c576757c9732.svg";